<!-- Show basic information about a twin -->
<template lang="pug">
.twin-details
  template(v-for="tp in twinProperties", :key="tp.uuid")
    .label.font-bold {{ tp.name }}
    TwinPropertyView(:prop="tp")
</template>

<script setup lang="ts">
import {
  stateError,
  stateInitial,
  stateLoaded,
  stateLoading,
} from "@shared/models/state";
import {
  searchTwins,
  type TwinResponse,
} from "@shared/services/twinManagement";
import { computed, onMounted, ref, watch } from "vue";
import TwinPropertyView from "./TwinPropertyView.vue";

const props = defineProps<{
  id: string;
}>();

const emit = defineEmits(["twin"]);

const loadState = ref({ ...stateInitial });

const result = computed<TwinResponse>(() => loadState.value.result);

const twinProperties = computed(() =>
  result.value?.properties
    .filter((p) => p.isUserRelevant)
    .sort((a, b) => a.order - b.order),
);

onMounted(loadData);
watch(() => props.id, loadData);

async function loadData() {
  loadState.value = { ...stateLoading };
  const response = await searchTwins(
    {
      page: 1,
      pageSize: 1,
    },
    {
      uuid: props.id,
    },
  ).catch((e) => {
    loadState.value = { ...stateError };
    throw e;
  });

  loadState.value = {
    ...stateLoaded,
    result: response.data.result?.[0] ?? null,
  };
  emit("twin", loadState.value.result);
}
</script>

<style scoped>
.twin-details {
  padding: 1rem;
  display: grid;
  grid-template-columns: max-content 1fr;
  row-gap: 0.5rem;
  background-color: white;
  border-radius: 1rem;
  column-gap: 1rem;
}
.label {
  justify-self: end;
}
</style>
